import { type PermissionType } from "features/Accounts/types";
import { type AccountBase } from "./AccountBase";

export interface Account extends AccountBase {
  accountTypeName: string;
  licensesCount: number;
  added: string;
  admins?: string[];
  imageUrl?: string;
  logoUri?: string;
  isDemo: boolean;
  canView: boolean;
  canDelete: boolean;
  userCount: number;
  permissionType: PermissionType;
  tags: string[];
}

export type AutocompleteAccount = { name: string; id: number; logoUri: string; exactMatch: boolean; isNew?: boolean };

export type AccountType = "bsi" | "sp" | "account";

export enum AccountTypeEnum {
  Customer = 1,
  SoftwareVendor,
  Distributor,
  BSI,
  ServiceProvider,
  CSP,
  MSP,
  Copilot,
}

// Account types that should hide the price component
export const HIDDEN_ACCOUNT_TYPES = [AccountTypeEnum.ServiceProvider, AccountTypeEnum.Distributor];
